import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LogService } from '@ottobock/shared/domain';

@Component({
  standalone: true,
  imports: [],
  selector: 'remote-update-feature-remote-update-details-remote-update-details',
  templateUrl: './remote-update-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./remote-update-details.component.scss']
})
export class RemoteUpdateDetailsComponent implements OnInit {
  logService = inject(LogService);
  ngOnInit() {
    this.logService.info('remote updade');
  }
}
